import Contract from "slotworks/utils/contract";
import * as TweenJS from "slotworks/utils/tween";
import RevolverWinTransitions from "./revolver-win-transitions";
import soundManager from "slotworks/sound/sound-manager";
import { FadeIn } from "slotworks/graphics/animation/base-animations";
import particles = require("pixi-particles");
import Layers from "slotworks/graphics/layers/layers";

export default class JackpotIntroTransitions extends RevolverWinTransitions {

    public TEXT_ZOOM_MIN = 0.75;
    public TEXT_ZOOM_MAX = 0.9;
    private explode: particles.Emitter;

    public in(): Contract<void> {
        return new Contract<void>((resolve) => {
            this.resetEverything();
            this.showJackpot();

            const explode = Layers.CelebrationForeground.getParticle("explodeJp");
            explode.emit = true;
            setTimeout(() => { explode.emit = false }, 500);

            FadeIn(RevolverWinTransitions.background, this.BOUNCE_TIME).execute();

            this.zoomInStacksJackpot(400).execute();
            RevolverWinTransitions.setOrientationChange();
            RevolverWinTransitions.glitter.emit = true;

            soundManager.customEvent("jackpot_win");
            const target = RevolverWinTransitions.winValue;
            target.scale.set(0, 0);
            setTimeout(() => {
                Contract.wrapTween(new TweenJS.Tween(target.scale)
                    .to({ x: this.TEXT_ZOOM_MIN, y: this.TEXT_ZOOM_MIN }, 2000)).then(() => {
                        new TweenJS.Tween(RevolverWinTransitions.winValue.scale)
                            .to({ x: this.TEXT_ZOOM_MAX, y: this.TEXT_ZOOM_MAX }, 2000)
                            .yoyo(true)
                            .repeat(Infinity)
                            .start();
                    });
            }, 1000);
            setTimeout(() => {
                const scaleMulti = 1.8;
                // todo add to psd with changed values when approved
                RevolverWinTransitions.coinsLeft.emit = true;
                RevolverWinTransitions.coinsRight.emit = true;
                RevolverWinTransitions.gemsLeft.emit = true;
                RevolverWinTransitions.gemsRight.emit = true;
                RevolverWinTransitions.coinsLeft.startScale *= scaleMulti;
                RevolverWinTransitions.coinsLeft.endScale *= scaleMulti;
                RevolverWinTransitions.coinsLeft.frequency *= 2;
                RevolverWinTransitions.coinsRight.startScale *= scaleMulti;
                RevolverWinTransitions.coinsRight.endScale *= scaleMulti;
                RevolverWinTransitions.coinsRight.frequency *= 2;
                RevolverWinTransitions.gemsLeft.startScale *= scaleMulti;
                RevolverWinTransitions.gemsLeft.frequency *= 2;
                RevolverWinTransitions.gemsLeft.endScale *= scaleMulti;
                RevolverWinTransitions.gemsRight.startScale *= scaleMulti;
                RevolverWinTransitions.gemsRight.endScale *= scaleMulti;
                RevolverWinTransitions.gemsRight.frequency *= 2;
            }, 1000);

            resolve(null);
        });
    }


    private showJackpot() {
        Layers.Custom.get("JackpotRuby").setScene("jackpot").execute();
        Layers.Custom.get("JackpotRuby").setScene("jackpot").then(() => {
            const loopAnim = Layers.Custom.get("JackpotRuby").getAnimatedSprite("jackpot_title_ruby_loop");
            loopAnim.anchor.set(0.5, 0.5);
            loopAnim.x += loopAnim.width / 2 - 30;
            loopAnim.y += loopAnim.height / 2 + 40;
            loopAnim.scale.set(0);
            loopAnim.loop = true;
            loopAnim.gotoAndPlay(0);

            const startY = loopAnim.y - 80;
            const bounceHeight = 60;
            const bounceSpeed = 625;
            const scaleSpeed = 250;

            // Scale in with TWEEN
            new TweenJS.Tween(loopAnim.scale)
                .to({ x: 1, y: 1 }, scaleSpeed)
                .onComplete(() => {
                    // Start bouncing after scale completes
                    const bounce = () => {
                        new TweenJS.Tween(loopAnim)
                            .to({ y: startY + bounceHeight }, bounceSpeed)
                            .onComplete(() => {
                                new TweenJS.Tween(loopAnim)
                                    .to({ y: startY }, bounceSpeed)
                                    .onComplete(bounce)
                                    .start();
                            })
                            .start();
                    };
                    bounce();
                })
                .start();
        });

    }

}